import React from "react";
import { useEffect } from "react";
import { Switch, Route, Redirect, useLocation } from "react-router-dom";

// components

import Navbar from "components/Navbars/AuthNavbar.js";
import FooterSmall from "components/Footers/FooterSmall.js";

// views

import Login from "views/auth/Login.js";
import Register from "views/auth/Register.js";
import PoliticaPrivacidad from "views/auth/PoliticaPrivacidad.js";
import RecuperarContrasena from "views/auth/RecuperarContraseña.js";
import RestablecerContrasena from "views/auth/RestablecerContrasena.js";
import RevisarPagos from "views/auth/RevisarPagos.js";
import PagoRealizado from "views/auth/PagoRealizado.js";

export default function Auth() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  return (
    <>
      <Navbar transparent />
      <main>
        <section className="relative w-full h-full py-40 min-h-screen">
          <div
            className="absolute top-0 w-full h-full bg-indigo-800 bg-no-repeat bg-full"
            style={{
              backgroundImage:
                "url(" + require("assets/img/register_bg_2.png").default + ")",
            }}
          ></div>
          <Switch>
            <Route path="/auth/login" exact component={Login} />
            <Route path="/auth/register" exact component={Register} />
            <Route path="/auth/politica-privacidad" exact component={PoliticaPrivacidad} />
            <Route path="/auth/recuperar-contrasena" exact component={RecuperarContrasena} />
            <Route path="/auth/restablecer-contrasena" exact component={RestablecerContrasena} />
            <Route path="/auth/pagos" exact component={RevisarPagos} />
            <Route path="/auth/pagos/success" exact component={PagoRealizado} />
            <Redirect from="/auth" to="/auth/login" />
          </Switch>
          <FooterSmall absolute />
        </section>
      </main>
    </>
  );
}
